import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

export type Breakpoint = keyof typeof breakpointsTailwind

export const useBreakpoint = () => {
  const breakpoints = useBreakpoints(breakpointsTailwind)
  return { breakpoints }
}
